import { playerMarkup } from "./playerMarkup";
import { paywallMarkup } from "./paywallMarkup";
import { ideaModalMarkup } from "./ideaModalMarkup";
import { aiCreateModalMarkup } from "./aiCreateModalMarkup";
import { successModalsMarkup } from "./successModalsMarkup";
import { verifyEmailMarkup } from "./verifyEmailMarkup";
import { cancelAutoRenewModalMarkup, profileModalsMarkup, upgradeConfirmModalMarkup, upgradeResumeModalMarkup } from "./profileMarkup";
import { legalModalMarkup } from "./legalModalMarkup";
import { communityIdeaDetailModalMarkup } from './communityDialogMarkups';
import { aiSubmissionDetailModalMarkup } from './aiSubmissionDialogMarkup';

export const mermaidFullscreenModalMarkup = String.raw`<!-- Mermaid Fullscreen Modal (enlarge article diagrams) -->
    <div class="modal-overlay" id="mermaidFullscreenModal" hidden>
      <div class="modal mermaid-fullscreen">
        <button type="button" class="modal-close modal-close--floating" data-proto-click="closeMermaidFullscreenModal()" aria-label="Close fullscreen diagram">
          <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
        <div class="mermaid-fullscreen-toolbar" role="toolbar" aria-label="Diagram zoom controls">
          <button type="button" class="mf-zoom-btn" id="mfZoomOut" aria-label="Zoom out" title="Zoom out">
            <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>
          </button>
          <span class="mf-zoom-level" id="mfZoomLevel" aria-live="polite">100%</span>
          <button type="button" class="mf-zoom-btn" id="mfZoomIn" aria-label="Zoom in" title="Zoom in">
            <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          </button>
          <button type="button" class="mf-zoom-btn mf-zoom-fit" id="mfZoomFit" aria-label="Fit to screen" title="Fit to screen">
            <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>
          </button>
        </div>
        <div class="mermaid-fullscreen-body" id="mermaidFullscreenBody"></div>
      </div>
    </div>
    `;

/**
 * Single source of truth for the overlay markup set mounted below the app
 * layout. Both the SPA shell (prototypeMarkup, Mode B) and the SSR document
 * (renderAppDocument, Mode A) must mount exactly this set so that any flow
 * which opens a modal on an SPA page can never find that modal missing on an
 * SSR Topic/Chapter page.
 *
 * Order is cosmetic but must stay stable across both consumers.
 */
export const modalMarkups = [
	playerMarkup,
	paywallMarkup,
	ideaModalMarkup,
	aiCreateModalMarkup,
	successModalsMarkup,
	verifyEmailMarkup,
	profileModalsMarkup,
	cancelAutoRenewModalMarkup,
	upgradeResumeModalMarkup,
	upgradeConfirmModalMarkup,
	legalModalMarkup,
	mermaidFullscreenModalMarkup,
	communityIdeaDetailModalMarkup,
	aiSubmissionDetailModalMarkup,
];
